(function () {
    var sectionId = document.currentScript.getAttribute('data-section-id');
    var rootSelector = '[data-length-preview][data-section-id="' + sectionId + '"]';
    var isEnglish = document.currentScript.getAttribute('data-is-english') === 'true';
    var localeCode = isEnglish ? 'en-US' : 'de-DE';
    var lpText = isEnglish ? {
      enterLength: 'Enter length',
      enterLengthWidth: 'Enter length and width',
      lengthUnits: 'Length and width in mm, cm and m',
      yourLength: 'Your length',
      inCentimeters: 'in centimeters',
      inMeters: 'in meters',
      yourWidth: 'Your width',
      widthMm: 'Width mm',
      widthCm: 'Width cm',
      widthM: 'Width m',
      lengthCm: 'Length cm',
      lengthM: 'Length m',
      lengthPrefix: 'Length: ',
      widthPrefix: 'Width: ',
      maxLengthWarning: 'Maximum ',
      maxLengthWarningSuffix: ' mm possible. Please check the value.',
      maxPlateWarningSuffix: ' mm per direction possible. Please check the values.',
      selectorCheck: 'Note: Check CSS selector.',
      selectorMissing: 'Note: Length field not found yet. Please set the CSS selector.'
    } : {
      enterLength: 'Länge eingeben',
      enterLengthWidth: 'Länge und Breite eingeben',
      lengthUnits: 'Länge und Breite in mm, cm und m',
      yourLength: 'Deine Länge',
      inCentimeters: 'in Zentimetern',
      inMeters: 'in Metern',
      yourWidth: 'Deine Breite',
      widthMm: 'Breite mm',
      widthCm: 'Breite cm',
      widthM: 'Breite m',
      lengthCm: 'Länge cm',
      lengthM: 'Länge m',
      lengthPrefix: 'Länge: ',
      widthPrefix: 'Breite: ',
      maxLengthWarning: 'Maximal ',
      maxLengthWarningSuffix: ' mm möglich. Bitte Wert prüfen.',
      maxPlateWarningSuffix: ' mm je Richtung möglich. Bitte Werte prüfen.',
      selectorCheck: 'Hinweis: CSS-Selector prüfen.',
      selectorMissing: 'Hinweis: Längenfeld noch nicht gefunden. Bitte CSS-Selector setzen.'
    };
    var currentScript = document.currentScript;

    function getCurrentRoot(container) {
      if (container && container.querySelector) {
        var localRoot = container.querySelector(rootSelector);

        if (localRoot) {
          return localRoot;
        }
      }

      if (currentScript && currentScript.closest) {
        var sectionWrapper = currentScript.closest('#shopify-section-' + sectionId);

        if (sectionWrapper) {
          var scriptRoot = sectionWrapper.querySelector(rootSelector);

          if (scriptRoot) {
            return scriptRoot;
          }
        }
      }

      return document.querySelector(rootSelector);
    }

    function removeOldCopies(currentRoot) {
  var copies = Array.prototype.slice.call(document.querySelectorAll('[data-length-preview]'));

  copies.forEach(function (copy) {
    if (copy !== currentRoot && copy.parentNode) {
      copy.parentNode.removeChild(copy);
    }
  });
}

    function initLengthPreview(container) {
      var root = getCurrentRoot(container);

      if (!root) {
        return;
      }

      removeOldCopies(root);

      var maxMm = Number(root.dataset.maxMm || 6000);

      if (!Number.isFinite(maxMm) || maxMm <= 0) {
        maxMm = 6000;
      }

      var targetSelector = (root.dataset.targetSelector || '').trim();

      var bar = root.querySelector('[data-lp-bar]');
      var marker = root.querySelector('[data-lp-marker]');
      var value = root.querySelector('[data-lp-value]');
      var units = root.querySelector('[data-lp-units]');
      var kpiMm = root.querySelector('[data-lp-kpi-mm]');
      var kpiCm = root.querySelector('[data-lp-kpi-cm]');
      var kpiM = root.querySelector('[data-lp-kpi-m]');
      var kpiWidthMm = root.querySelector('[data-lp-kpi-width-mm]');
      var kpiWidthCm = root.querySelector('[data-lp-kpi-width-cm]');
      var kpiWidthM = root.querySelector('[data-lp-kpi-width-m]');
      var kpiLengthSecondary = root.querySelector('[data-lp-kpi-length-secondary]');
      var kpiWidthSecondary = root.querySelector('[data-lp-kpi-width-secondary]');
      var maxLabel = root.querySelector('[data-lp-max-label]');
      var message = root.querySelector('[data-lp-message]');
      var plate = root.querySelector('[data-lp-plate]');
      var plateShape = root.querySelector('[data-lp-plate-shape]');
      var plateLength = root.querySelector('[data-lp-plate-length]');
      var plateWidth = root.querySelector('[data-lp-plate-width]');
      var kpiMmLabel = kpiMm ? kpiMm.nextElementSibling : null;
      var kpiCmLabel = kpiCm ? kpiCm.nextElementSibling : null;
      var kpiMLabel = kpiM ? kpiM.nextElementSibling : null;
      var kpiWidthMmLabel = kpiWidthMm ? kpiWidthMm.nextElementSibling : null;
      var kpiWidthCmLabel = kpiWidthCm ? kpiWidthCm.nextElementSibling : null;
      var kpiWidthMLabel = kpiWidthM ? kpiWidthM.nextElementSibling : null;

      var selectorError = '';

      var numberFormat = new Intl.NumberFormat(localeCode, {
        maximumFractionDigits: 3
      });

      var unitFormat = new Intl.NumberFormat(localeCode, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3
      });

      if (maxLabel) {
        maxLabel.textContent = numberFormat.format(maxMm) + ' mm';
      }

      function parseLength(inputValue) {
        var raw = String(inputValue || '').trim().replace(/\s/g, '');

        if (!raw) {
          return NaN;
        }

        var germanThousands = /^\d{1,3}(\.\d{3})+(,\d+)?$/.test(raw);

        if (germanThousands) {
          return Number(raw.replace(/\./g, '').replace(',', '.'));
        }

        return Number(raw.replace(',', '.'));
      }

      function getInputText(input) {
        var text = '';

        if (input.id && window.CSS && CSS.escape) {
          var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');

          if (label) {
            text += ' ' + label.textContent;
          }
        }

        var parentLabel = input.closest('label');

        if (parentLabel) {
          text += ' ' + parentLabel.textContent;
        }

        text += ' ' + (input.name || '');
        text += ' ' + (input.id || '');
        text += ' ' + (input.placeholder || '');
        text += ' ' + (input.getAttribute('aria-label') || '');

        return text.toLowerCase();
      }

      function findInputLabel(input) {
        if (!input) {
          return null;
        }

        if (input.id && window.CSS && CSS.escape) {
          var linkedLabel = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');

          if (linkedLabel && !linkedLabel.closest('[data-length-preview]')) {
            return linkedLabel;
          }
        }

        var parentLabel = input.closest('label');

        if (parentLabel && !parentLabel.closest('[data-length-preview]')) {
          return parentLabel;
        }

        var node = input;

        for (var i = 0; node && node !== document.body && i < 6; i++, node = node.parentElement) {
          var sibling = node.previousElementSibling;

          for (var j = 0; sibling && j < 4; j++, sibling = sibling.previousElementSibling) {
            if (sibling.matches && sibling.matches('script, style')) {
              continue;
            }

            var siblingText = (sibling.textContent || '').replace(/\s+/g, ' ').trim();

            if (/^L(?:\u00e4|ae)nge\b/i.test(siblingText) || /^Length\b/i.test(siblingText)) {
              return sibling;
            }

            if (sibling.querySelector) {
              var labels = sibling.querySelectorAll('label, .variant__label, [class*="label"]');

              for (var labelIndex = 0; labelIndex < labels.length; labelIndex++) {
                var labelText = (labels[labelIndex].textContent || '').replace(/\s+/g, ' ').trim();

                if (/^L(?:\u00e4|ae)nge\b/i.test(labelText) || /^Length\b/i.test(labelText)) {
                  return labels[labelIndex];
                }
              }
            }
          }
        }

        return null;
      }

      function commonAncestor(firstElement, secondElement) {
        if (!firstElement || !secondElement) {
          return null;
        }

        var ancestors = [];
        var node = firstElement;

        while (node) {
          ancestors.push(node);
          node = node.parentElement;
        }

        node = secondElement;

        while (node) {
          if (ancestors.indexOf(node) !== -1) {
            return node;
          }

          node = node.parentElement;
        }

        return null;
      }

      function directChildOf(parent, child) {
        var node = child;

        while (node && node.parentElement !== parent) {
          node = node.parentElement;
        }

        return node;
      }

      function findLengthFieldInsertAfter(input, fallbackAnchor, label) {
        var productBlock = input.closest('.product-block');

        if (productBlock && !productBlock.closest('[data-length-preview]')) {
          return productBlock;
        }

        var inputShell =
          input.closest(
            '.field, .form-field, .product-form__input, .line-item-property__field, .input-wrapper, .form__input-wrapper'
          ) ||
          input.parentElement ||
          input;

        if (!label) {
          return inputShell || fallbackAnchor || input;
        }

        if (label.contains(inputShell)) {
          return label;
        }

        if (inputShell.contains(label)) {
          return inputShell;
        }

        var sharedParent = commonAncestor(label, inputShell);

        if (sharedParent && sharedParent !== document.body && sharedParent !== document.documentElement) {
          var inputPiece = directChildOf(sharedParent, inputShell);
          var labelPiece = directChildOf(sharedParent, label);

          if (inputPiece && labelPiece && inputPiece !== labelPiece) {
            return inputPiece;
          }
        }

        return inputShell || fallbackAnchor || input;
      }

      function findBySelector(selector) {
        if (!selector) {
          return null;
        }

        try {
          var selected = document.querySelector(selector);

          if (!selected) {
            return null;
          }

          if (selected.matches && selected.matches('input')) {
            return selected;
          }

          if (selected.querySelector) {
            return selected.querySelector('input');
          }

          return null;
        } catch (error) {
          selectorError = error.message || 'Ungültiger CSS-Selector.';
          return null;
        }
      }

      function findInputByKeywords(keywords) {
        var inputs = Array.prototype.slice.call(
          document.querySelectorAll('input[type="number"], input[type="text"], input:not([type])')
        );

        return inputs.find(function (input) {
          if (input.closest('[data-length-preview]')) {
            return false;
          }

          var text = getInputText(input);

          return keywords.some(function (keyword) {
            return text.indexOf(keyword) !== -1;
          });
        });
      }

      function findLengthInput() {
        var selectedInput = findBySelector(targetSelector);

        if (selectedInput) {
          return selectedInput;
        }

        return findInputByKeywords(['länge', 'laenge', 'length', 'max. 6000', '6000 mm']);
      }

      function findWidthInput() {
        return findInputByKeywords(['breite', 'width']);
      }

      function setMessage(text, isWarning) {
        if (!message) {
          return;
        }

        message.textContent = text || '';
        message.hidden = !text;

        if (isWarning) {
          message.classList.add('is-warning');
        } else {
          message.classList.remove('is-warning');
        }
      }

      function resetPreview() {
        root.classList.remove('is-plate-mode');
        if (plate) plate.hidden = true;
        if (plateShape) {
          plateShape.style.width = '0px';
          plateShape.style.height = '0px';
        }
        if (bar) bar.style.width = '0%';
        if (marker) marker.style.left = '0%';
        if (value) value.textContent = lpText.enterLength;
        if (units) units.textContent = 'mm · cm · m';
        if (kpiMm) kpiMm.textContent = '– mm';
        if (kpiCm) kpiCm.textContent = '– cm';
        if (kpiM) kpiM.textContent = '– m';
        if (kpiMmLabel) kpiMmLabel.textContent = lpText.yourLength;
        if (kpiCmLabel) kpiCmLabel.textContent = lpText.inCentimeters;
        if (kpiMLabel) kpiMLabel.textContent = lpText.inMeters;
        if (kpiWidthMm) kpiWidthMm.textContent = '–';
        if (kpiWidthCm) kpiWidthCm.textContent = '–';
        if (kpiWidthM) kpiWidthM.textContent = '–';
        if (kpiWidthMmLabel) kpiWidthMmLabel.textContent = lpText.widthMm;
        if (kpiWidthCmLabel) kpiWidthCmLabel.textContent = lpText.widthCm;
        if (kpiWidthMLabel) kpiWidthMLabel.textContent = lpText.widthM;
        if (kpiLengthSecondary) kpiLengthSecondary.textContent = '';
        if (kpiWidthSecondary) kpiWidthSecondary.textContent = '';
        if (plateLength) plateLength.textContent = lpText.lengthPrefix + '–';
        if (plateWidth) plateWidth.textContent = lpText.widthPrefix + '–';

        setMessage('', false);
      }

      function resetPlatePreview() {
        root.classList.add('is-plate-mode');
        if (plate) plate.hidden = false;
        if (plateShape) {
          plateShape.style.width = '0px';
          plateShape.style.height = '0px';
        }
        if (bar) bar.style.width = '0%';
        if (marker) marker.style.left = '0%';
        if (value) value.textContent = lpText.enterLengthWidth;
        if (units) units.textContent = lpText.lengthUnits;
        if (kpiMm) kpiMm.textContent = '\u2013 mm';
        if (kpiCm) kpiCm.textContent = '\u2013';
        if (kpiM) kpiM.textContent = '\u2013';
        if (kpiWidthMm) kpiWidthMm.textContent = '\u2013 mm';
        if (kpiWidthCm) kpiWidthCm.textContent = '\u2013';
        if (kpiWidthM) kpiWidthM.textContent = '\u2013';
        if (kpiMmLabel) kpiMmLabel.textContent = lpText.yourLength;
        if (kpiCmLabel) kpiCmLabel.textContent = lpText.lengthCm;
        if (kpiMLabel) kpiMLabel.textContent = lpText.lengthM;
        if (kpiWidthMmLabel) kpiWidthMmLabel.textContent = lpText.yourWidth;
        if (kpiWidthCmLabel) kpiWidthCmLabel.textContent = lpText.widthCm;
        if (kpiWidthMLabel) kpiWidthMLabel.textContent = lpText.widthM;
        if (kpiLengthSecondary) kpiLengthSecondary.textContent = '\u2013 cm / \u2013 m';
        if (kpiWidthSecondary) kpiWidthSecondary.textContent = '\u2013 cm / \u2013 m';
        if (plateLength) plateLength.textContent = lpText.lengthPrefix + '\u2013';
        if (plateWidth) plateWidth.textContent = lpText.widthPrefix + '\u2013';

        setMessage('', false);
      }

      function updateLengthPreview(input) {
        var lengthMm = parseLength(input.value);
        root.classList.remove('is-plate-mode');
        if (plate) plate.hidden = true;
        if (kpiMmLabel) kpiMmLabel.textContent = lpText.yourLength;
        if (kpiCmLabel) kpiCmLabel.textContent = lpText.inCentimeters;
        if (kpiMLabel) kpiMLabel.textContent = lpText.inMeters;
        if (kpiLengthSecondary) kpiLengthSecondary.textContent = '';
        if (kpiWidthSecondary) kpiWidthSecondary.textContent = '';

        if (!Number.isFinite(lengthMm) || lengthMm <= 0) {
          resetPreview();
          return;
        }

        var visibleLength = Math.min(lengthMm, maxMm);
        var percent = Math.max(0, Math.min(100, (visibleLength / maxMm) * 100));

        var mmValue = numberFormat.format(lengthMm);
        var cmValue = unitFormat.format(lengthMm / 10);
        var mValue = unitFormat.format(lengthMm / 1000);

        if (bar) bar.style.width = percent + '%';
        if (marker) marker.style.left = percent + '%';

        if (value) value.textContent = mmValue + ' mm';
        if (units) units.textContent = cmValue + ' cm · ' + mValue + ' m';

        if (kpiMm) kpiMm.textContent = mmValue + ' mm';
        if (kpiCm) kpiCm.textContent = cmValue + ' cm';
        if (kpiM) kpiM.textContent = mValue + ' m';

        if (lengthMm > maxMm) {
          setMessage(lpText.maxLengthWarning + numberFormat.format(maxMm) + lpText.maxLengthWarningSuffix, true);
          return;
        }

        setMessage('', false);
      }

      function updatePlatePreview(lengthInput, widthInput) {
        var lengthMm = parseLength(lengthInput && lengthInput.value);
        var widthMm = parseLength(widthInput && widthInput.value);

        root.classList.add('is-plate-mode');
        if (plate) plate.hidden = false;
        if (kpiMmLabel) kpiMmLabel.textContent = lpText.yourLength;
        if (kpiCmLabel) kpiCmLabel.textContent = lpText.lengthCm;
        if (kpiMLabel) kpiMLabel.textContent = lpText.lengthM;
        if (kpiWidthMmLabel) kpiWidthMmLabel.textContent = lpText.yourWidth;
        if (kpiWidthCmLabel) kpiWidthCmLabel.textContent = lpText.widthCm;
        if (kpiWidthMLabel) kpiWidthMLabel.textContent = lpText.widthM;

        if (!Number.isFinite(lengthMm) || lengthMm <= 0 || !Number.isFinite(widthMm) || widthMm <= 0) {
          resetPlatePreview();
          return;
        }

        var lengthMmLabel = numberFormat.format(lengthMm) + ' mm';
        var lengthCmLabel = unitFormat.format(lengthMm / 10) + ' cm';
        var lengthMLabel = unitFormat.format(lengthMm / 1000) + ' m';
        var widthMmLabel = numberFormat.format(widthMm) + ' mm';
        var widthCmLabel = unitFormat.format(widthMm / 10) + ' cm';
        var widthMLabel = unitFormat.format(widthMm / 1000) + ' m';
        var ratio = lengthMm / widthMm;
        var stage = plateShape ? plateShape.parentElement : null;
        var stageWidth = stage ? Math.max(120, stage.clientWidth - 28) : 320;
        var stageHeight = stage ? Math.max(80, stage.clientHeight - 28) : 128;
        var stageRatio = stageWidth / stageHeight;
        var shapeWidth = stageWidth;
        var shapeHeight = stageHeight;

        if (ratio >= stageRatio) {
          shapeHeight = stageWidth / ratio;
        } else {
          shapeWidth = stageHeight * ratio;
        }

        shapeWidth = Math.max(24, Math.round(shapeWidth));
        shapeHeight = Math.max(24, Math.round(shapeHeight));

        if (plateShape) {
          plateShape.style.width = shapeWidth + 'px';
          plateShape.style.height = shapeHeight + 'px';
        }

        if (value) value.textContent = lengthMmLabel + ' \u00d7 ' + widthMmLabel;
        if (units) units.textContent = lpText.lengthPrefix + lengthCmLabel + ' / ' + lengthMLabel + ' · ' + lpText.widthPrefix + widthCmLabel + ' / ' + widthMLabel;
        if (kpiMm) kpiMm.textContent = lengthMmLabel;
        if (kpiCm) kpiCm.textContent = lengthCmLabel;
        if (kpiM) kpiM.textContent = lengthMLabel;
        if (kpiWidthMm) kpiWidthMm.textContent = widthMmLabel;
        if (kpiWidthCm) kpiWidthCm.textContent = widthCmLabel;
        if (kpiWidthM) kpiWidthM.textContent = widthMLabel;
        if (kpiLengthSecondary) kpiLengthSecondary.textContent = lengthCmLabel + ' / ' + lengthMLabel;
        if (kpiWidthSecondary) kpiWidthSecondary.textContent = widthCmLabel + ' / ' + widthMLabel;
        if (plateLength) plateLength.textContent = lpText.lengthPrefix + lengthMmLabel;
        if (plateWidth) plateWidth.textContent = lpText.widthPrefix + widthMmLabel;

        if (lengthMm > maxMm || widthMm > maxMm) {
          setMessage(lpText.maxLengthWarning + numberFormat.format(maxMm) + lpText.maxPlateWarningSuffix, true);
          return;
        }

        setMessage('', false);
      }

      function updatePreview(lengthInput, widthInput) {
        if (widthInput && widthInput !== lengthInput) {
          updatePlatePreview(lengthInput, widthInput);
          return;
        }

        updateLengthPreview(lengthInput);
      }

      function showInEditor() {
        if (window.Shopify && Shopify.designMode && root.hidden) {
          root.hidden = false;
          setMessage(
            selectorError
              ? lpText.selectorCheck
              : lpText.selectorMissing,
            true
          );
        }
      }

      function mount(scheduleFollowups) {
        var input = findLengthInput();
        var widthInput = findWidthInput();

        if (!input) {
          return false;
        }

        var anchor =
          input.closest(
            '.field, .form-field, .product-form__input, .line-item-property__field, .input-wrapper, .form__input-wrapper'
          ) ||
          input.parentElement ||
          input;

        var lengthLabel = findInputLabel(input);
        var insertAfter = findLengthFieldInsertAfter(input, anchor, lengthLabel);

        if (insertAfter && (root.parentNode !== insertAfter.parentNode || root.previousElementSibling !== insertAfter)) {
          insertAfter.insertAdjacentElement('afterend', root);
        }

        root.hidden = false;

        updatePreview(input, widthInput);

        function bindDimensionInput(dimensionInput) {
          if (!dimensionInput || dimensionInput.dataset.lengthPreviewBound === sectionId) {
            return;
          }

          dimensionInput.dataset.lengthPreviewBound = sectionId;

          dimensionInput.addEventListener('input', function () {
            updatePreview(input, findWidthInput());
          });

          dimensionInput.addEventListener('change', function () {
            updatePreview(input, findWidthInput());
          });
        }

        bindDimensionInput(input);
        bindDimensionInput(widthInput);

        if (!root.dataset.lengthPreviewResizeBound) {
          root.dataset.lengthPreviewResizeBound = sectionId;

          window.addEventListener('resize', function () {
            var latestInput = findLengthInput() || input;
            var latestWidthInput = findWidthInput();

            updatePreview(latestInput, latestWidthInput);
          });
        }

        if (scheduleFollowups !== false) {
          [250, 750, 1500].forEach(function (delay) {
            window.setTimeout(function () {
              mount(false);
              var latestWidthInput = findWidthInput();
              bindDimensionInput(latestWidthInput);
              updatePreview(findLengthInput() || input, latestWidthInput);
            }, delay);
          });
        }

        return true;
      }

      if (!mount(true)) {
        var observer = new MutationObserver(function () {
          if (mount(true)) {
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        window.setTimeout(function () {
          observer.disconnect();
          showInEditor();
        }, 3000);
      }
    }

    initLengthPreview();

    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail && event.detail.sectionId === sectionId) {
        window.setTimeout(function () {
          initLengthPreview(event.target);
        }, 0);
      }
    });
  })();
